import {
  IDashboardObject,
  IDataWidgetCustomDasboard,
  IWidgetMetaData
} from 'src/models/customDashboard';
import { INotification } from 'src/models/general';
import { buildDataLineGroup } from 'src/utils/buildDataLineGroup';

export const customDashboardDummy: IDashboardObject = {
  id: 'sample',
  name: 'Sample',
  displayName: 'Sample',
  createdAt: new Date(),
  sourceType: 'socmed',
  clippingOnm: null,
  clippingOfm: null,
  objectList: [],
  objectGroupList: [],
  customDashboardWidgetMetadataList: []
};

export const widgetsDummy: IWidgetMetaData = {
  id: '3283b731-8d4e-11ec-819c-02420a00002a',
  metric: 'postmade',
  description: null,
  size: 4,
  displayName: 'Post Made',
  title:
    'Amount of posts that the social profiles published in specific selected timeframe.',
  visualization: 'bar_chart',
  category: 'content',
  source_type: 'socmed'
};

export const widgetDataDummy: IDataWidgetCustomDasboard = {
  responseType: 'chronological',
  details: {
    numericWithGrowth: null,
    nameValue: null,
    chronologicalGroup: null,
    chronological: {
      contentType: 'postMade',
      values: [
        {
          timestamp: '2025-11-19T00:00:00.000+08:00',
          value: 791
        },
        {
          timestamp: '2025-11-20T00:00:00.000+08:00',
          value: 671
        },
        {
          timestamp: '2025-11-21T00:00:00.000+08:00',
          value: 675
        },
        {
          timestamp: '2025-11-22T00:00:00.000+08:00',
          value: 501
        },
        {
          timestamp: '2025-11-23T00:00:00.000+08:00',
          value: 561
        },
        {
          timestamp: '2025-11-24T00:00:00.000+08:00',
          value: 840
        },
        {
          timestamp: '2025-11-25T00:00:00.000+08:00',
          value: 708
        },
        {
          timestamp: '2025-11-26T00:00:00.000+08:00',
          value: 281
        }
      ]
    },
    user: null,
    peakTime: null,
    table: null,
    groupSentiment: null,
    numericOutput: null,
    onlineMediaStream: null,
    quotationWithPersonGroup: null
  }
};

export const dummyWidgetSeries = buildDataLineGroup([
  widgetDataDummy.details.chronological
]);

export const dummyNotification: INotification[] = [
  {
    id: '94e17996-fc49-4495-974a-691609ab6129',
    title: 'Initialize Data',
    typeNotification: 'update',
    subTypeNotification: 'firstTimeSocialMediaData',
    status: 'success',
    totalProgress: 0,
    currentProgress: 0,
    createdAt: new Date(),
    detail: null
  }
];

export const dummiesObjectComparison = [
  {
    name: 'kemenhub151-X',
    id: '60362d2e-d19b-4eb1-8f40-e1de469c9862'
  },
  {
    name: 'kemenhub151-instagram',
    id: '860deba6-826b-409a-b819-54f383317e2d'
  },
  {
    name: '#KebaikanIsiPiringku-youtube',
    id: 'b1fcbacc-c937-4114-a191-a8d1e27bc694'
  }
];
